// extracted by mini-css-extract-plugin
export default {"countryLink":"FlagCountryNameBlock_countryLink__5IvFR","countryText":"FlagCountryNameBlock_countryText__QWrla","countryFlag":"FlagCountryNameBlock_countryFlag__eb6Vj"};